import { ListItemText, MenuItem, Stack } from '@mui/material';
import { FC, MouseEvent, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppDispatch } from '../../../../../../../types';
import { BaseMenuItemText } from '../../../../../../design_system/inputs/menuI-items/BaseMenuItemText';
import CalibrateIcon from '../../../../../../../assets/icons/calibrate.svg?react';
import { push } from 'redux-first-history';

type Props = {
    onActionExecuted: () => void;
};

export const CalibrateFromImageMenuItem: FC<Props> = ({ onActionExecuted }) => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();

    const handleClick = useCallback(
        (event: MouseEvent<HTMLElement>) => {
            event.stopPropagation();
            onActionExecuted();
            dispatch(push('/acquisition/calibration'));
        },
        [dispatch, onActionExecuted],
    );

    return (
        <MenuItem onClick={handleClick}>
            <Stack direction="row" gap="10px" alignItems="center">
                <CalibrateIcon />
                <ListItemText>
                    <BaseMenuItemText>{t('streetView.calibrateButton')}</BaseMenuItemText>
                </ListItemText>
            </Stack>
        </MenuItem>
    );
};
